"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var useAppContext_1 = require("./useAppContext");
var react_1 = require("react");
function useDataLayerOnConfirmation(eventName) {
    var _a;
    var deal = useAppContext_1.default().deal;
    var dataLayer = (_a = window.dataLayer, (_a !== null && _a !== void 0 ? _a : null));
    react_1.useEffect(function () {
        if (!deal || null === dataLayer) {
            return;
        }
        var eventData = {
            event: eventName,
            model: deal.fullProductConfiguration.model.title,
            variant: deal.fullProductConfiguration.title,
        };
        window.dataLayer.push(eventData);
    }, [deal.journeyType, dataLayer]);
}
exports.default = useDataLayerOnConfirmation;
